import React from 'react';
export var StylesContext = React.createContext({
    ready: false,
    set: null,
    get: null,
    getDefaultValue: null,
    reset: null,
    resetAll: null,
    changeSiteColors: null,
    getStylesForAllBreakpoints: null,
});
export var StylesConsumer = StylesContext.Consumer;
//# sourceMappingURL=StylesContext.js.map